import React, { useState } from "react";
import "./FAQ.css";
import Icon from "../Icon";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import SEO from "../SEO";
import { business } from "../../seo/business";

const faqData = [
  {
    category: "General",
    questions: [
      {
        question: "What are your office hours?",
        answer:
          `We are open ${business.hoursSummary}.`,
      },
      {
        question: "Where is Benson Dental Studio located?",
        answer:
          "We are located at 2260 Benson Ave, Brooklyn, NY 11214, on the corner of 23rd Ave. We're a short walk from the Bay Parkway and 25th Avenue D train stations and serve patients from Bensonhurst, Sheepshead Bay, Bay Ridge, Gravesend, Bath Beach, and across South Brooklyn.",
      },
      {
        question: "How do I schedule an appointment?",
        answer:
          "Call us at 718-266-5889 during office hours and we'll find a convenient time. You can also email hello@bensondentalstudio.com, though replies may take a few days.",
      },
      {
        question: "Do you have Russian- or Ukrainian-speaking staff?",
        answer:
          "Yes. Our team speaks English, Russian, and Ukrainian, so you can talk through your treatment, insurance, and aftercare in the language you're most comfortable with.",
      },
      {
        question: "Do you see patients from Sheepshead Bay, Bay Ridge, and other parts of South Brooklyn?",
        answer:
          "Yes. Many of our patients come from Sheepshead Bay, Bay Ridge, Dyker Heights, Gravesend, and Bath Beach. Our office on Benson Ave is easy to reach from the Belt Parkway's Bay Parkway exit or by the D train.",
      },
      {
        question: "What ages do you treat?",
        answer:
          "We welcome patients ages 14 and up.",
      },
    ],
  },
  {
    category: "Insurance & Payment",
    questions: [
      {
        question: "What insurance plans do you accept?",
        answer:
          "We accept most major insurance plans including Aetna, Cigna, Guardian, UnitedHealthcare, MetLife, EmblemHealth, and Delta Dental. If your insurance is not listed, please call us and we'll check for you.",
      },
      {
        question: "What if I don't have dental insurance?",
        answer:
          "We believe everyone deserves quality dental care. We work with CareCredit and offer flexible in-office payment options for extensive treatments. Please ask our staff about available options.",
      }
    ],
  },
  {
    category: "Services",
    questions: [
      {
        question: "What services do you offer?",
        answer:
          "We offer comprehensive dental care including preventive services (cleanings, exams), cosmetic dentistry (whitening, veneers), restorative treatments (crowns, bridges), periodontics, oral surgery, endodontics (root canals), prosthodontics (dentures, implants), and emergency dental care.",
      },
      {
        question: "Do you offer emergency dental services?",
        answer:
          "Yes, we provide emergency dental care for urgent issues like severe toothaches, broken teeth, and dental infections. If you have a dental emergency during office hours, please call us immediately at 718-266-5889.",
      },
      {
        question: "Do you do dental implants?",
        answer:
          "Yes, we offer dental implant services including single implants and implant-supported dentures. We also provide bone grafting if needed to prepare for implant placement.",
      },
      {
        question: "What cosmetic dental procedures do you offer?",
        answer:
          "Our cosmetic services include professional teeth whitening, porcelain veneers, and smile makeovers. We can help you achieve the beautiful, confident smile you've always wanted.",
      },
    ],
  },
  {
    category: "First Visit",
    questions: [
      {
        question: "What should I expect at my first visit?",
        answer:
          "Your first visit will include a comprehensive oral exam, X-rays if needed, and a professional cleaning. We'll discuss your dental history, any concerns you have, and create a personalized treatment plan. Please arrive 15 minutes early to complete paperwork.",
      },
      {
        question: "What should I bring to my first appointment?",
        answer:
          "Please bring your photo ID, insurance card (if applicable), a list of current medications, and any previous dental records or X-rays if available. If you have dental anxiety, let us know so we can help make you comfortable.",
      },
      {
        question: "I'm nervous about going to the dentist. Can you help?",
        answer:
          "Absolutely! Dr. Aga understands dental anxiety firsthand and is committed to making every patient feel comfortable. We take time to explain each procedure, work at your pace, and offer a gentle approach to all treatments.",
      },
    ],
  },
  {
    category: "Cosmetic Dentistry",
    questions: [
      {
        question: "How long does professional teeth whitening last?",
        answer:
          "Professional whitening results typically last 1-3 years depending on your diet and oral care habits. Coffee, tea, red wine, and tobacco can cause staining to return sooner. We offer both in-office and take-home whitening options so you can maintain your bright smile.",
      },
      {
        question: "Are porcelain veneers permanent?",
        answer:
          "Veneers are considered a permanent treatment because a thin layer of enamel is removed to place them. However, the veneers themselves last 10-15 years or longer with proper care before they may need replacement. They are highly stain-resistant and maintain their natural appearance over time.",
      },
      {
        question: "Can cosmetic dentistry fix crooked teeth without braces?",
        answer:
          "Yes. Porcelain veneers can create the appearance of straighter teeth without orthodontics. These are good options when the underlying bite is healthy and the misalignment is primarily cosmetic. During a consultation, we can determine which approach is right for you.",
      },
      {
        question: "Do you offer clear aligners?",
        answer:
          "Yes, we offer clear aligner therapy as a discreet alternative to traditional braces. Clear aligners are custom-made, removable trays that gradually straighten your teeth without metal brackets or wires. They're a great option for mild to moderate crowding, spacing, and bite issues. We'll evaluate your case and let you know if aligners are right for you.",
      },
    ],
  },
  {
    category: "Dental Implants & Oral Surgery",
    questions: [
      {
        question: "How long do dental implants last?",
        answer:
          "Dental implants are designed to be a permanent solution. The titanium implant post can last a lifetime with proper oral hygiene, while the crown on top typically lasts 15-20 years before it may need replacement. Implants are the closest option to natural teeth in both function and appearance.",
      },
      {
        question: "Am I a good candidate for dental implants?",
        answer:
          "Most adults with good general health are candidates for dental implants. You need adequate jawbone density to support the implant. If bone has been lost, a bone graft can rebuild it. Conditions like uncontrolled diabetes or heavy smoking can affect healing. We evaluate each patient individually with 3D imaging to determine the best approach.",
      },
      {
        question: "How painful is a tooth extraction?",
        answer:
          "Modern extractions are performed under local anesthesia, so you won't feel pain during the procedure, only pressure. After the extraction, mild to moderate discomfort is normal for a few days and is manageable with over-the-counter pain medication. We provide detailed aftercare instructions to keep you comfortable during healing.",
      },
      {
        question: "What is a bone graft and when is it needed?",
        answer:
          "A bone graft adds bone material to your jaw to rebuild areas where bone has been lost due to tooth loss, gum disease, or injury. It's commonly needed before placing dental implants to ensure there's enough bone to anchor the implant securely. The graft heals over several months as your natural bone grows around it.",
      },
    ],
  },
  {
    category: "Root Canals & Restorations",
    questions: [
      {
        question: "What does a root canal feel like?",
        answer:
          "A root canal is performed under local anesthesia and feels similar to getting a filling. You may feel pressure but not pain. Most patients are surprised by how comfortable it is. Afterward, mild soreness is normal for a day or two. The procedure saves your natural tooth and eliminates the infection causing your pain.",
      },
      {
        question: "How long does a dental crown last?",
        answer:
          "A well-made dental crown typically lasts 10-15 years, and many last even longer with good oral hygiene. Porcelain and ceramic crowns look natural and are very durable. Avoiding habits like chewing ice or grinding your teeth helps extend the life of a crown.",
      },
      {
        question: "When do I need a crown vs. a filling?",
        answer:
          "A filling works well for small to moderate cavities where the tooth structure is still mostly intact. A crown is recommended when a tooth is significantly damaged, cracked, or weakened, for example after a root canal or a large fracture. The crown covers and protects the entire tooth, restoring its strength and shape.",
      },
      {
        question: "What's the difference between an inlay and a crown?",
        answer:
          "An inlay is a custom restoration that fits inside the cusps of a tooth. It's used when damage is too extensive for a filling but not enough to require a full crown. A crown covers the entire visible portion of the tooth. Inlays preserve more of your natural tooth structure and are a conservative option for moderate decay or damage.",
      },
    ],
  },
  {
    category: "Gum Disease & Prevention",
    questions: [
      {
        question: "What are the signs of gum disease?",
        answer:
          "Early signs include red, swollen, or bleeding gums, especially when brushing or flossing. As gum disease progresses, you may notice persistent bad breath, receding gums, or loose teeth. Regular dental checkups catch gum disease early when it's most treatable.",
      },
      {
        question: "How often should I get a dental cleaning?",
        answer:
          "Most patients benefit from a professional cleaning every 6 months. If you have a history of gum disease, we may recommend cleanings every 3-4 months (periodontal maintenance) to keep your gums healthy and prevent the condition from returning.",
      },
      {
        question: "What is scaling and root planing?",
        answer:
          "Scaling and root planing is a deep cleaning procedure used to treat gum disease. Scaling removes plaque and tartar from below the gum line, while root planing smooths the tooth roots so gums can reattach properly. It's performed under local anesthesia and is usually done in two visits, one side of the mouth at a time.",
      },
    ],
  },
];

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="faq-item">
      <button
        className={`faq-question ${isOpen ? "open" : ""}`}
        onClick={onClick}
        aria-expanded={isOpen}
        aria-controls={`faq-answer-${question.replace(/\s+/g, "-").toLowerCase()}`}
      >
        <span>{question}</span>
        <Icon icon={isOpen ? faMinus : faPlus} />
      </button>
      <div
        id={`faq-answer-${question.replace(/\s+/g, "-").toLowerCase()}`}
        className={`faq-answer ${isOpen ? "open" : ""}`}
        role="region"
        aria-hidden={!isOpen}
      >
        <p>{answer}</p>
      </div>
    </div>
  );
};

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setOpenItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <main className="center-container fade-in">
      <SEO
        title="Frequently Asked Questions"
        description="Answers to common questions at Benson Dental Studio in Bensonhurst, Brooklyn: hours, insurance, languages, implants, veneers, root canals, gum disease and your first visit."
        canonical="/faq"
      />
      <div className="faq-container">
        <header className="faq-header">
          <h1>Frequently Asked Questions</h1>
          <p>
            Find answers to common questions about our dental services, insurance,
            and what to expect at your visit.
          </p>
        </header>

        {faqData.map((category, categoryIndex) => (
          <section
            key={categoryIndex}
            className="faq-category"
            aria-labelledby={`category-${categoryIndex}`}
          >
            <h2 id={`category-${categoryIndex}`}>{category.category}</h2>
            <div className="faq-list">
              {category.questions.map((item, questionIndex) => (
                <FAQItem
                  key={questionIndex}
                  question={item.question}
                  answer={item.answer}
                  isOpen={openItems[`${categoryIndex}-${questionIndex}`] || false}
                  onClick={() => toggleItem(categoryIndex, questionIndex)}
                />
              ))}
            </div>
          </section>
        ))}

        <section className="faq-contact">
          <h2>Still have questions?</h2>
          <p>
            We're here to help! Call us at{" "}
            <a href="tel:718-266-5889" aria-label="Call us at 718-266-5889">
              718-266-5889
            </a>{" "}
            or{" "}
            <a href="/contact" aria-label="Go to contact page">
              send us a message
            </a>
            .
          </p>
        </section>
      </div>

      {/* Schema.org FAQ structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqData.flatMap((category) =>
              category.questions.map((item) => ({
                "@type": "Question",
                name: item.question,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: item.answer,
                },
              }))
            ),
          }),
        }}
      />
    </main>
  );
};

export default FAQ;
